<template>
  <el-main>
    <div class="logout-page">
      <el-row class="logout-panel-holder" type="flex" justify="left" align="middle">
        <el-col :span="24">
          <h3>กำลังออกจากระบบ...</h3>
        </el-col>
      </el-row>
    </div>
  </el-main>
</template>

<script>
const LogoutView = {
  name: 'logout',
  mounted() {
    this.$store.dispatch('LOGOUT', {
      vm: this,
    }).then(() => {
      this.$message({
        type: 'success',
        showClose: true,
        duration: 10000,
        message: this.$t('Successfully logged out.'),
      });
      this.$router.push({ name: 'Login' });
    }).catch((err) => {
      // console.error(err);
      this.$log.error(err);
    });
  },
};
export default LogoutView;
</script>

<style lang="scss">
  .logout-page {
    height: 100%;
    .logout-panel-holder {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/logout.vue